// Minimal shared store for a fatal authentication error captured during MSAL
// bootstrap (handleRedirectPromise). App reads this on mount so a failed login
// redirect renders an error screen instead of re-triggering login (redirect loop).

let initialAuthError: unknown = null;

export function setInitialAuthError(error: unknown): void {
  initialAuthError = error;
}

export function getInitialAuthError(): unknown {
  return initialAuthError;
}

export function clearInitialAuthError(): void {
  initialAuthError = null;
}

export function getAuthErrorMessage(error: unknown): string {
  if (!error) {
    return 'Unknown authentication error.';
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}
